import React, {Component} from 'react';
import './HomePage.css';
import {ProfileCard, suggestionsActions} from '../profile';
import {CommunityCard} from '../community';
import {connect} from 'react-redux';
import {DocumentTitle} from '../widgets';
import {Link} from 'react-router-dom';
import {searchActions} from '../search/';
import uiActions from '../chrome/ui.actions';

class HomePage extends Component {
	componentDidMount() {
		this.props.startSuggestions();
	}

	componentWillUnmount() {
		this.props.stopSuggestions();
	}

	render() {
		const {communities, session, signup, setSearchFor, communityCategories} = this.props;

		return (
			<DocumentTitle title="B2Me">
				<main className="HomePage">
					<div className="HomePage-intro-copy">
						<h1>
							<span>Welcome to </span>
							<img src="/img/b2me-full.svg" alt="B2Me" />
						</h1>
						<p>
							<em>B2Me</em> helps you to find people that you can trust from your community.
						</p>
					</div>
					<div className="HomePage-communities">
						<p>Find providers from these local communities, and more.</p>
						<ul>
							{communities &&
								communities.map(community => {
									return (
										<li key={community.uuid}>
											<ul>
												<CommunityCard community={community} />
											</ul>
											<ul>
												{community.suggestedMembers &&
													community.suggestedMembers.map(provider => (
														<ProfileCard key={provider.uuid} provider={provider} />
													))}
											</ul>
										</li>
									);
								})}
						</ul>
					</div>
					{communityCategories ? (
						<ul className="HomePage-communityCatgories">
							<li>Explore the marketplace through communities:</li>
							{communityCategories.map(cat => (
								<CategoryCard key={cat} setSearchFor={setSearchFor} category={cat} />
							))}
						</ul>
					) : (
						undefined
					)}
				</main>
			</DocumentTitle>
		);
	}
}

const ENCODE_SPACES = / /g; // Encode spaces as underscores due to double encoding

/**
 * Community category card, which allows users to browser nearby communities via the search function.
 */
const CategoryCard = ({category, setSearchFor}) => {
	return (
		<li className="HomePage-CategoryCard" onClick={setSearchFor}>
			<Link to={`/search/category:${category.replace(ENCODE_SPACES, '_')}`}>
				<div>{category}</div>
			</Link>
		</li>
	);
};

const ConnectedHomePage = connect(
	state => ({
		communities: state.suggestions && state.suggestions.communities,
		session: state.session && state.session.current,
		communityCategories: state.categories && state.categories.community
	}),
	dispatch => ({
		startSuggestions: () => dispatch(suggestionsActions.commenceSuggestions()),
		stopSuggestions: () => dispatch(suggestionsActions.suggestionsStopped()),
		signup: () => dispatch(uiActions.uiModal('signup')),
		clearSearch: () => dispatch(searchActions.searchSetQuery('')),
		setSearchFor: () => dispatch(searchActions.searchFor('community'))
	})
)(HomePage);

export default ConnectedHomePage;



// WEBPACK FOOTER //
// ./src/home/HomePage.js